import { DownloadIcon } from "@primer/octicons-react";
import { Box, Flash } from '@primer/react';
import { useEffect, useState } from 'react';
import { meetingApi } from '../../api/meetingApi';
import ComboboxMeeting from '../../components/combobox-meeting';
import { PlaceHolder } from '../../components/place-holder';
import Button from "../../components/ui/button";
import DataGrid from '../../components/ui/data-grid';
import { NotifyHelper } from '../../helpers/toast';
import { useWindowSize } from '../../hooks/useWindowSize';
import { IMeetingRegistration } from '../../models/response/meeting/IMeetingRegistration';
import moment from "moment";
import ComboboxClubRegistration from "../../components/combobox-club";
import { IClubRegistrationHistory } from "../../models/response/club/IClubRegistrationHistory";
import { clubApi } from "../../api/clubApi";


const ClubRegistrationHistory = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [dataSource, setDataSource] = useState<IClubRegistrationHistory[]>([]);
    const [selectedMeetingId, setSelectedMeetingId] = useState<number>(0);
    const { height } = useWindowSize();
    const [filterdData, setFilterdData] = useState<any[]>();

    useEffect(() => {
        handleInit();
    }, []);

    const handleInit = async () => {
        await Promise.all([
            handleGetData()
        ]);
    };

    const handleGetData = async (meetingId?: number) => {
        setIsLoading(true);

        const res = await clubApi.clubRegisterResult(meetingId ?? 0);

        if (res.is_success) {
            setDataSource(res.data);
        } else {
            NotifyHelper.Error(res.message ?? "");
        }

        setIsLoading(false);
    };

    const handleChangeMeeting = (value: number) => {
        setSelectedMeetingId(value);
        handleGetData(value);
    };

    return (
        <Box>
            {isLoading && <PlaceHolder line_number={10} />}

            {!isLoading && (
                <DataGrid
                    height={height - 230}
                    onDataSourceFilterd={setFilterdData}
                    exportConfig={{
                        enable: true,
                        fileName: "download",
                        render: () => {
                            return (
                                <Button text='Tải xuống' leadingVisual={DownloadIcon} />
                            );
                        }
                    }}
                    actionComponent={
                        < Box>
                            <ComboboxClubRegistration
                                onValueChanged={(id) => {
                                    handleChangeMeeting(id)
                                }}
                                value={selectedMeetingId}
                            />
                        </Box>
                    }
                    columns={[
                        {
                            id: "ma_hs",
                            caption: "Mã học sinh",
                            cellRender: (data: IMeetingRegistration) => (
                                <Box>
                                    <Box sx={{ fontWeight: "bold" }}>
                                        {data.ma_hs}
                                    </Box>
                                </Box>
                            )
                        },
                        {
                            id: "student",
                            caption: "Học sinh",
                            cellRender: (data: IMeetingRegistration) => (
                                <Box>
                                    <Box sx={{ fontWeight: "bold" }}>
                                        {data.ho_ten}
                                    </Box>
                                </Box>
                            )
                        },
                        {
                            id: "registered_by",
                            caption: "Người đăng ký",
                            dataField: "registered_by"
                        },
                        {
                            id: "time",
                            caption: "Thời gian đăng ký",
                            cellRender: (data: IMeetingRegistration) => (
                                <Box>
                                    {moment(data.registered_at).format("DD/MM/YYYY HH:mm")}
                                </Box>
                            )
                        }
                    ]}
                    dataSource={dataSource}
                    searchEnable
                    subTitle={`Tổng số: ${dataSource.length}`}
                    paging={{
                        enable: true,
                        pageSize: 50,
                        pageSizeItems: [50, 100, 200]
                    }}
                />
            )}
            {!isLoading && dataSource.length === 0 && (
                <Flash>
                    Không có dữ liệu đăng ký
                </Flash>
            )}
        </Box>
    );
};

export default ClubRegistrationHistory;